export default __webpack_public_path__ + "static/media/depot.2da06efa.svg";